import { render } from "./AddManufacturingOrder.vue?vue&type=template&id=a510ccba&scoped=true"
import script from "./AddManufacturingOrder.vue?vue&type=script&lang=js"
export * from "./AddManufacturingOrder.vue?vue&type=script&lang=js"

import "./AddManufacturingOrder.vue?vue&type=style&index=0&id=a510ccba&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a510ccba"]])

export default __exports__